export * from './ContactTypeI18n';
